import styled from 'styled-components';

export const BillboardAdWrapper = styled.div<{ adHeight: number }>`
  ${(props) => `height: ${props.adHeight}px`};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
